<template> 
    <div id="idBotones" class="ui basic medium buttons" style="width: 100%;">
      <button
      type="button"
      class="ui button"
      :class="{ active: value === true }"
      id="idFirstOption"
      :disabled="theDisabledOption"
      @click="updateValue(true)"
    >
        {{ theFirstOption }}
      </button>
      <button
        type="button"
        class="ui button"
        :class="{ active: value === false }"
        id="idSecondOption"
        :disabled = "theDisabledOption"
        @click="updateValue(false)"
      >
        {{ theSecondOption }}
      </button>
    </div>
</template>

<script>
export default {
  name: 'selectOption',
  props: {
    value: {
      type: Boolean,
    },
    theFirstOption: {
      type: String,
      default: "Si",
    },
    theSecondOption: {
      type: String,
      default: "No",
    },
    theDisabledOption: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.applyActiveClassStyle();
  },
  watch: {
    value: 'applyActiveClassStyle',
    theFirstOption: 'applyActiveClassStyle',
    theSecondOption: 'applyActiveClassStyle',
    theDisabledOption: 'applyActiveClassStyle',
  },
  methods: {
    applyActiveClassStyle() {
      const btnFirstOption = document.getElementById('idFirstOption')
      const btnSecondOption = document.getElementById('idSecondOption')

      btnFirstOption.style = (this.value) ? "background-color: #00f9a9 !important" : "background-color: transparent !important"
      btnSecondOption.style = (!this.value) ? "background-color: #00f9a9 !important" : "background-color: transparent !important"
    },

    updateValue(data) {
      this.$emit('input', data);
      this.applyActiveClassStyle()
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/selectOption.vue